import axios from 'axios';
import { getAuthToken } from './auth';

const api = axios.create({
  baseURL: 'https://prod.dalchetong.api.misae.us',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers['Authorization'] = `Token ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
